import { object, string } from 'yup';

export const ingredientModalConstants = {
  INGREDIENT_NAME_PLACEHOLDER: 'Enter ingredient name',
  PACKAGING_MATERIAL_NAME_PLACEHOLDER: 'Enter packaging material name',
  OTHER_MATERIAL_NAME_PLACEHOLDER: 'Enter other material name',
  INGREDIENT_NAME: 'ingredientName',
  INGREDIENT_ORIGIN: 'ingredientOrigin',
  QUANTITY: 'quantity',
  UNIT: 'unit',
  HAVE_SUB_INGREDIENT: 'have_sub_ingredient',
  SUB_INGREDIENT_LIST: 'sub_ingredient_list',
  INGREDIENT_ORIGIN_PLACEHOLDER: 'Enter origin',
  QUANTITY_ORIGIN_PLACEHOLDER: 'Enter quantity',
  UNIT_PLACEHOLDER: 'Enter unit',
  HAVE_SUB_INGREDIENT_PLACEHOLDER: 'Does this ingredient have sub ingredients?',
  SUB_INGREDIENT_LIST_PLACEHOLDER: 'Please spcify the sub ingredients',
  ADDITIONAL_DETAILS: 'additionalDetails',
  ADDITIONAL_DETAILS_PLACEHOLDER: 'Enter Additional Information (i.e. Organic)',
  FERTILISER_MATERIAL_NAME_PLACEHOLDER: 'Enter fertiliser material name',
  FEED_MATERIAL_NAME_PLACEHOLDER: 'Enter feed material name',
};
export const ModalProps = {
  HEADING: 'Request new ingredient',
  HEADING_PACKAGING: 'Request new packaging material',
  HEADING_OTHER: 'Request new other material',
  HEADING_FERTILISER: 'Request new fertiliser material',
  HEADING_FEED: 'Request new feed material',
  SUBMIT: 'Submit',
  THANK_YOU_INGREDIENT_TEXT:
    'Thanks for your request. We will notify you once the ingredient has been updated',
  THANK_YOU_PACKAGING_TEXT:
    'Thanks for your request. We will notify you once the packaging material has been updated',
  THANK_YOU_OTHER_TEXT:
    'Thanks for your request. We will notify you once the other material has been updated',
  THANK_YOU_FERTILISER_TEXT:
    'Thanks for your request. We will notify you once the fertiliser material has been updated',
  THANK_YOU_FEED_TEXT:
    'Thanks for your request. We will notify you once the feed material has been updated',
};

export const ingredientValidationSchema = object({
  ingredientName: string().required('Required'),
  ingredientOrigin: string().required('Required'),
  additionalDetails: string().required('Required'),
  quantity: string().required('Required'),
  unit: string().required('Required'),
  have_sub_ingredient: string().required('Required'),
  sub_ingredient_list: string().when(['have_sub_ingredient'], {
    is: 'true',
    then: string().required('Required'),
  }),
});

export const packagingValidationSchema = object({
  ingredientName: string().required('Required'),
  ingredientOrigin: string().required('Required'),
  additionalDetails: string().required('Required'),
});
